import editBtn from "@assets/images/edit_btn.svg";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { CustomerMaterialsQuery } from "@saleor/graphql";
import { renderCollection } from "@saleor/misc";
import React, { useEffect, useRef, useState } from "react";
import InlineSVG from "react-inlinesvg";

import DialogAddMatSuccess from "../DialogAddMatSuccess";
import DialogConfirmEdit from "../DialogConfirmEdit";
import DialogEditMaterial from "../DialogEditMaterial";
import useStyles from "./styles";

interface TableEditMaterial {
  tableData: CustomerMaterialsQuery;
  isAddCustomerMat?: boolean;
  onEditMat?: (data: any) => void;
  onUpdateTableData?: (updatedData: any) => void;
}

const TableEditMaterial: React.FC<TableEditMaterial> = ({
  tableData,
  isAddCustomerMat = false,
  onUpdateTableData
}) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [confirmEditItemData, setConfirmEditItemData] = useState(null);
  const [openConfirmEditDialog, setOpenConfirmEditDialog] = useState<boolean>(
    false
  );
  const [editMaterialItemData, setEditMaterialItemData] = useState(null);
  const [isEditSuccess, setIsEditSuccess] = useState(false);
  const [isFromEditSuccess, setIsFromEditSuccess] = useState(false);
  const [openAddSuccess, setOpenAddSuccess] = useState(false);

  useEffect(() => {
    if (tableData.customerMaterials.length > 0 && !isFromEditSuccess) {
      setIsEditSuccess(false);
    }
    if (isFromEditSuccess) {
      setIsFromEditSuccess(false);
    }
  }, [tableData]);

  const onEditMaterial = (data: any) => {
    setErrorsEdit(null);
    setOpenEditDialog(true);
    setEditMaterialItemData(data);
  };

  const [errorsEdit, setErrorsEdit] = useState(null);
  const handleConfirmEditMat = (data: any) => {
    setOpenEditDialog(false);
    setOpenConfirmEditDialog(true);
    setConfirmEditItemData({
      oldDataItem: editMaterialItemData,
      newDataItem: data
    });
    setErrorsEdit(null);
  };

  const handleConfirmEditMatError = (errors: {
    materialCode?: boolean;
    soldToMaterialCode?: boolean;
    materialCodeValue?: boolean;
    soldToMaterialCodeValue?: boolean;
  }) => {
    setErrorsEdit(errors);
    setOpenConfirmEditDialog(false);
    setOpenEditDialog(true);
  };

  const handleEditSuccess = successData => {
    setOpenEditDialog(false);
    setOpenConfirmEditDialog(false);
    setEditMaterialItemData(null);
    setConfirmEditItemData(null);
    if (successData && onUpdateTableData) {
      setIsFromEditSuccess(true);
      setIsEditSuccess(true);
      const updatedCustomerMaterials = tableData.customerMaterials
        .filter(item => item.id === successData.id)
        .map(item => {
          if (item.id === successData.id) {
            return { ...item, ...successData.data };
          }
          return item;
        });
      onUpdateTableData({
        customerMaterials: updatedCustomerMaterials
      });
      setOpenAddSuccess(true);
    }
  };

  return (
    <>
      <h3 className={classes.title}>
        {isAddCustomerMat
          ? "รายการที่เพิ่มล่าสุด"
          : isEditSuccess
          ? "แก้ไขล่าสุด"
          : "ผลการค้นหา"}
      </h3>
      <div className={classes.containerTable}>
        <div className={classes.rootTable} ref={containerRef}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCellHeader textAlign="left" className={classes.colLine1}>
                  <MyTypography variant="subtitle3">Sold-to Party</MyTypography>
                </TableCellHeader>
                <TableCellHeader textAlign="left" className={classes.colLine2}>
                  <MyTypography variant="subtitle3">
                    Sales Organization
                  </MyTypography>
                </TableCellHeader>
                <TableCellHeader
                  textAlign="center"
                  className={classes.colLine3}
                >
                  <MyTypography variant="subtitle3">Channel</MyTypography>
                </TableCellHeader>
                <TableCellHeader textAlign="left" className={classes.colLine2}>
                  <MyTypography variant="subtitle3">
                    Customer Material
                  </MyTypography>
                </TableCellHeader>
                <TableCellHeader textAlign="left" className={classes.colLine4}>
                  <MyTypography variant="subtitle3">Material Code</MyTypography>
                </TableCellHeader>
                <TableCellHeader textAlign="left" className={classes.colLine3}>
                  <MyTypography variant="subtitle3">Edit</MyTypography>
                </TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderCollection(tableData.customerMaterials, (item, index) => (
                <TableRow key={index}>
                  <TableCell align="left" className={classes.colLine1}>
                    <MyTypography variant="body3">
                      {item?.soldTo?.displayText || "-"}
                    </MyTypography>
                  </TableCell>

                  <TableCell align="left" className={classes.colLine2}>
                    <MyTypography variant="body3">
                      {item?.salesOrganization?.displayText || "-"}
                    </MyTypography>
                  </TableCell>

                  <TableCell align="center" className={classes.colLine3}>
                    <MyTypography variant="body3">
                      {item?.distributionChannelCode || "-"}
                    </MyTypography>
                  </TableCell>

                  <TableCell align="left" className={classes.colLine2}>
                    <MyTypography variant="body3">
                      {item?.soldToMaterialCode || "-"}
                    </MyTypography>
                  </TableCell>

                  <TableCell align="left" className={classes.colLine4}>
                    <MyTypography variant="body3">
                      {item?.materialCode || "-"}
                    </MyTypography>
                  </TableCell>
                  <TableCell align="left" className={classes.colLine3}>
                    <MyTypography
                      variant="body3"
                      className={classes.btnEdit}
                      onClick={() => onEditMaterial(item)}
                    >
                      <InlineSVG src={editBtn} />
                    </MyTypography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <StickyHorizontalScrollBar container={containerRef} bottom={160} />
        </div>
      </div>
      {openEditDialog && (
        <DialogEditMaterial
          open={openEditDialog}
          onConfirm={data => handleConfirmEditMat(data)}
          data={editMaterialItemData ? editMaterialItemData : null}
          errorsEdit={errorsEdit}
          onClose={() => {
            setOpenEditDialog(false);
            setOpenConfirmEditDialog(false);
          }}
          onClearErrors={field => {
            setErrorsEdit(prev => ({
              ...prev,
              [field]:
                field === "soldToMaterialCodeValue" ||
                field === "materialCodeValue"
                  ? ""
                  : false
            }));
          }}
        />
      )}
      {openConfirmEditDialog && (
        <DialogConfirmEdit
          open={openConfirmEditDialog}
          onSuccess={data => handleEditSuccess(data)}
          onError={handleConfirmEditMatError}
          dataItem={confirmEditItemData ? confirmEditItemData : null}
          onClose={() => {
            setOpenConfirmEditDialog(false);
            setOpenEditDialog(true);
          }}
        />
      )}
      {openAddSuccess && (
        <DialogAddMatSuccess
          open={openAddSuccess}
          title="แก้ไขข้อมูลสำเร็จ"
          onClose={() => setOpenAddSuccess(false)}
        />
      )}
    </>
  );
};
export default TableEditMaterial;
